import ar from 'i18n/ar'
import da from 'i18n/da'
import en from 'i18n/en'
import fi from 'i18n/fi'
import no from 'i18n/no'
import se from 'i18n/se'
import de from 'i18n/de'
import it from 'i18n/it'
import es from 'i18n/es'
import nl from 'i18n/nl'
import fr from 'i18n/fr'
import pl from 'i18n/pl'
import el from 'i18n/el'
import ro from 'i18n/ro'
import bg from 'i18n/bg'
import hu from 'i18n/hu'
import uk from 'i18n/uk'
import cs from 'i18n/cs'
import hr from 'i18n/hr'
import sk from 'i18n/sk'
import sl from 'i18n/sl'
import sr from 'i18n/sr'
import et from 'i18n/et'
import zh from 'i18n/zh'
import pt from 'i18n/pt'
import ru from 'i18n/ru'
import ja from 'i18n/ja'
import tr from 'i18n/tr'
import ko from 'i18n/ko'
import zhTW from 'i18n/zh-tw'
import { MapStateToProps } from 'react-redux'

export const languages = {
  ar,
  da,
  de,
  en,
  fi,
  no,
  se,
  it,
  es,
  nl,
  fr,
  pl,
  el,
  ro,
  bg,
  hu,
  uk,
  cs,
  hr,
  sk,
  sl,
  sr,
  ru,
  et,
  zh,
  pt,
  ja,
  tr,
  ko,
  'zh-tw': zhTW,
}

export type Language = keyof typeof languages

export const liveLanguageList = () => {
  return [
    { code: 'fi', label: 'suomi' },
    { code: 'se', label: 'svenska' },
    { code: 'en', label: 'English' },
  ]
}

export const languageList = (candidateSide?: boolean) => {
  const list = [
    { code: 'da', label: 'dansk' },
    { code: 'de', label: 'Deutsch' },
    { code: 'en', label: 'English' },
    { code: 'es', label: 'español' },
    { code: 'it', label: 'italiano' },
    { code: 'no', label: 'norsk' },
    { code: 'fi', label: 'suomi' },
    { code: 'se', label: 'svenska' },
    { code: 'ru', label: 'русский язык' },
    { code: 'ja', label: '日本語 ' },
  ]
  if (candidateSide) {
    list.push({ code: 'ar', label: 'العربية الفصحى' }) // TODO: Check if this is the correct translation?
    list.push({ code: 'bg', label: 'български' })
    list.push({ code: 'cs', label: 'čeština' })
    list.push({ code: 'el', label: 'Ελληνικά' })
    list.push({ code: 'et', label: 'eesti' })
    list.push({ code: 'fr', label: 'français' })
    list.push({ code: 'hr', label: 'hrvatski jezik' })
    list.push({ code: 'hu', label: 'magyar' })
    list.push({ code: 'ko', label: '한국어' })
    list.push({ code: 'nl', label: 'Nederlands' })
    list.push({ code: 'pl', label: 'polski' })
    list.push({ code: 'pt', label: 'Português' })
    list.push({ code: 'ro', label: 'Română' })
    list.push({ code: 'sk', label: 'Slovenčina' })
    list.push({ code: 'sl', label: 'Slovenski' })
    list.push({ code: 'sr', label: 'српски језик' })
    list.push({ code: 'tr', label: 'Türkçe' })
    list.push({ code: 'uk', label: 'Українська' })
    list.push({ code: 'zh', label: '中文' })
    list.push({ code: 'zh-tw', label: '中文（繁體）' })
  }
  return list
}

export function mapLanguageToProps<
  TStateProps = Record<string, never>,
  TOwnProps = Record<string, never>,
  State = Record<string, never>
>(
  languages: Record<string, any>,
  key: string,
  map?: MapStateToProps<TStateProps, TOwnProps, State>
) {
  return (state: any, props: any) => {
    const {
      global: { language, session },
    } = state
    if (key === 'previewBanner') {
      const lang = session.user.language
      const i18n = languages[lang].page
      return { ...(map ? map(state, props) : {}), i18n, language: lang }
    }
    const i18n = languages[language] && languages[language][key]
    return { ...(map ? map(state, props) : {}), i18n, language }
  }
}

export function mapLanguageToMoment(language: Language) {
  switch (language) {
    case 'se':
      return 'sv'
    case 'no':
      return 'nn'
    case 'zh':
      return 'zh-cn'
    default:
      return language
  }
}

export function mapLanguageToComponentProps<
  TStateProps = Record<string, never>,
  TOwnProps = Record<string, never>,
  State = Record<string, never>
>(map?: MapStateToProps<TStateProps, TOwnProps, State>) {
  return mapLanguageToProps(languages, 'component', map)
}

export function mapLanguageToPageProps<
  TStateProps = Record<string, never>,
  TOwnProps = Record<string, never>,
  State = Record<string, never>
>(map?: MapStateToProps<TStateProps, TOwnProps, State>) {
  return mapLanguageToProps(languages, 'page', map)
}

export function mapLanguageToPreviewBannerProps<
  TStateProps = Record<string, never>,
  TOwnProps = Record<string, never>,
  State = Record<string, never>
>(map?: MapStateToProps<TStateProps, TOwnProps, State>) {
  return mapLanguageToProps(languages, 'previewBanner', map)
}

export function getValidLanguage(lang: Language) {
  return lang in languages ? lang : 'en'
}

export function signatureLanguage(lang: Language) {
  return languages[lang in languages ? lang : 'en'].global.signature
}

export function smsInvitationMessageLanguage(lang: Language) {
  return languages[lang in languages ? lang : 'en'].component.smsMessages
}
